import IpubMenus from './src/main'
import IpubMenusItem from './src/item'

/* istanbul ignore next */
IpubMenus.install = function(Vue) {
  Vue.component(IpubMenus.name, IpubMenus)
  Vue.component(IpubMenusItem.name, IpubMenusItem)
}

export default IpubMenus
